var name = "roboflow-staging";
var env = "staging";
var emulated;
const _ = require("lodash");

function checkGACSync() {
    if (typeof process == "undefined" || process.browser || emulated) {
        return true;
    }
    if (process.env.GOOGLE_APPLICATION_CREDENTIALS) {
        if (!process.env.GAC_PROJECT) {
            console.log(
                "Environment variable GOOGLE_ACCOUNT_CREDENTIALS is set, but was not set with secrets.sh. Please use secrets.sh gac to set it instead, exiting."
            );
            process.exit(1);
        }

        if (process.env.GCLOUD_PROJECT) {
            if (process.env.GCLOUD_PROJECT !== process.env.GAC_PROJECT) {
                console.log(
                    "Environment variable GCLOUD_PROJECT does not match the project set in secrets.sh, exiting.",
                    process.env.GCLOUD_PROJECT,
                    process.env.GAC_PROJECT,
                    process.env.GOOGLE_APPLICATON_CREDENTIALS
                );
                process.exit(1);
            }
        }

        if (name !== process.env.GAC_PROJECT) {
            console.log(
                "projectSelector is using a project name that is not in sync with what secrets.sh used, exiting.",
                name,
                process.env.GAC_PROJECT
            );
            process.exit(1);
        }
    }
}

if (typeof process != "undefined" && !process.browser) {
    emulated = !!process.env.FUNCTIONS_EMULATOR;

    if (!emulated && process.env.GCLOUD_PROJECT == "roboflow-platform") {
        name = "roboflow-platform";
        env = "prod";
    }
} else {
    // Check if running on local development subdomains
    const localSubdomains = [
        "localhost",
        "localhost.roboflow.com",
        "localhost.staging.roboflow.com",
        "localhost.roboflow.one",
        "localapp.roboflow.one",
        "localapi.roboflow.one",
        "localuniverse.roboflow.one",
        "localrapid.roboflow.one",
        "localadmin.roboflow.one",
        "localdemo.roboflow.one",
        "localreferrals.roboflow.one",
        "rapid-localhost.roboflow.one"
    ];

    emulated = localSubdomains.includes(window.location.hostname);

    if (
        window.location.hostname == "app.roboflow.com" ||
        window.location.hostname == "public.roboflow.com" ||
        window.location.hostname == "public2.roboflow.com" ||
        window.location.hostname == "admin.roboflow.com" ||
        window.location.hostname == "models.roboflow.com" ||
        window.location.hostname == "universe.roboflow.com" ||
        window.location.hostname == "rapid.roboflow.com" ||
        window.location.hostname == "johndeere.roboflow.com" ||
        window.location.hostname == "johndeere-dev.roboflow.com" ||
        window.location.hostname == "bnsf.roboflow.com" ||
        window.location.hostname == "pella.roboflow.com" ||
        window.location.hostname == "ussvision.roboflow.com" ||
        window.location.hostname == "ussteel.roboflow.com" ||
        window.location.hostname == "simplot.roboflow.com" ||
        window.location.hostname == "ripcord.roboflow.com" ||
        window.location.hostname == "degould.roboflow.com" ||
        window.location.hostname == "oc.roboflow.com" ||
        window.location.hostname == "cummins.roboflow.com"
    ) {
        name = "roboflow-platform";
        env = "prod";
    }
}

if (global.FORCE_PROD) {
    name = "roboflow-platform";
    env = "prod";
}

if (global.FORCE_STAGING) {
    name = "roboflow-staging";
    env = "staging";
}
checkGACSync();

const project = {
    isLocal: function () {
        return emulated;
    },
    sessionCookieName: function () {
        return project.isLocal() ? "__session_local" : "__session";
    },
    env: function () {
        return env;
    },
    name: function () {
        return name;
    },
    release: function () {
        return process.env.K_VERSION || "Unknown";
    },
    isSSODomain: function () {
        const hostname = window.location?.hostname;
        const forbiddenDomains = [
            "universe.roboflow.com",
            "universe.roboflow.one",
            "public.roboflow.com",
            "public.roboflow.one",
            "models.roboflow.com",
            "models.roboflow.one",
            "admin.roboflow.com",
            "admin.roboflow.one"
        ];
        if (forbiddenDomains.includes(hostname)) {
            throw new Error(`You shouldnt be using isSSODomain() in this ${hostname} domain`);
        }
        const defaultDomains = [
            "localhost.roboflow.one",
            "localapp.roboflow.one",
            "app.roboflow.one",
            "app.roboflow.com",
            "localrapid.roboflow.one",
            "rapid-localhost.roboflow.one"
        ];
        return !defaultDomains.includes(hostname);
    },
    cookieDomain: function () {
        return env === "prod" ? ".roboflow.com" : ".roboflow.one";
    },
    appUrl: function (hash, full) {
        if (emulated && hash) return "https://localhost:5000/#app";
        if (emulated && !full) return "https://localapp.roboflow.one";
        return env == "prod" ? "https://app.roboflow.com" : "https://app.roboflow.one";
    },
    trainAppUrl: function () {
        return env == "prod" ? "https://app.roboflow.com" : "https://app.roboflow.one";
    },
    dataUrl: function () {
        return env == "prod" ? "https://public.roboflow.com" : "https://public.roboflow.one";
    },
    universeUrl: function (hash, full) {
        if (emulated && hash) return "https://localuniverse.roboflow.one/#universe";
        if (emulated && !full) return "https://localuniverse.roboflow.one";
        return env == "prod" ? "https://universe.roboflow.com" : "https://universe.roboflow.one";
    },
    rapidUrl: function (hash, full) {
        if (emulated && hash) return "https://localrapid.roboflow.one/#rapid";
        if (emulated && !full) return "https://localrapid.roboflow.one";
        return env == "prod" ? "https://rapid.roboflow.com" : "https://rapid.roboflow.one";
    },
    rapidStreamApiUrl: function () {
        // Firebase hosting buffers the response on staging/prod.
        // We need to call the cloud function directly to enable streaming responses.
        if (emulated) {
            return "https://localrapid.roboflow.one";
        } else if (env == "prod") {
            return "https://us-central1-roboflow-platform.cloudfunctions.net/rapid-v2-server";
        } else {
            return "https://us-central1-roboflow-staging.cloudfunctions.net/rapid-v2-server";
        }
    },
    universeRateLimitBypassKey: function () {
        return "jojofromroro";
    },
    dataCacheUrl: function (force) {
        if (emulated && !force) return "";
        if (emulated) return "http://localhost:5000";
        return env == "prod" ? "https://public2.roboflow.com" : "https://public2.roboflow.one";
    },
    modelsUrl: function () {
        if (emulated) return "http://localhost:5000";
        return env == "prod" ? "https://models.roboflow.com" : "https://models.roboflow.one";
    },
    inferUrlV1: function (datasetType) {
        if (datasetType == "classification") {
            return env == "prod"
                ? "https://classify.roboflow.com"
                : "https://lambda-classification.staging.roboflow.com";
        } else if (datasetType == "instance-segmentation") {
            return env == "prod"
                ? "https://outline.roboflow.com"
                : "https://lambda-instance-segmentation.staging.roboflow.com";
        } else if (datasetType == "semantic-segmentation") {
            return env == "prod"
                ? "https://segment.roboflow.com"
                : "https://lambda-semantic-segmentation.staging.roboflow.com";
        } else {
            return env == "prod"
                ? "https://detect.roboflow.com"
                : "https://lambda-object-detection.staging.roboflow.com";
        }
    },
    inferUrl: function (datasetType) {
        if (datasetType == "classification") {
            return env == "prod"
                ? "https://serverless.roboflow.com"
                : "https://serverless.roboflow.one";
        } else if (datasetType == "instance-segmentation") {
            return env == "prod"
                ? "https://serverless.roboflow.com"
                : "https://serverless.roboflow.one";
        } else if (datasetType == "semantic-segmentation") {
            return env == "prod"
                ? "https://segment.roboflow.com"
                : "https://lambda-semantic-segmentation.staging.roboflow.com";
        } else {
            return env == "prod"
                ? "https://serverless.roboflow.com"
                : "https://serverless.roboflow.one";
        }
    },
    serverlessUrl: function () {
        return env == "prod"
            ? "https://serverless.roboflow.com"
            : "https://serverless.roboflow.one";
    },
    assetsCdnUrl: function () {
        return env == "prod" ? "https://cdnassets.roboflow.com" : "https://cdnassets.roboflow.one";
    },
    guestApiKey: function () {
        return process.env.GUEST_API_KEY;
    },
    deprecatedInferWorkflowUrl: function () {
        return env == "prod"
            ? "https://serverless.roboflow.com/infer/workflows"
            : "https://serverless.roboflow.one/infer/workflows";
    },
    workflowUrl: function (workspaceUrl, workflowUrl) {
        const baseUrl =
            env == "prod" ? "https://serverless.roboflow.com" : "https://serverless.roboflow.one";
        return `${baseUrl}/${workspaceUrl}/workflows/${workflowUrl}`;
    },
    dedicatedDeploymentsDomain: function () {
        return env == "prod" ? "roboflow.cloud" : "staging.roboflow.cloud";
    },
    inferUsageCount: function () {
        return {
            usageCountsUrl: `${process.env.INFER_USAGE_COUNT_URL}?context=usage_counts`,
            cachedInferencesUrl: `${process.env.INFER_USAGE_COUNT_URL}?context=cached_inferences`
        };
    },
    inferUsageClear: function () {
        return {
            usageCountsUrl: `${process.env.INFER_USAGE_CLEAR_URL}?context=usage_counts`,
            cachedInferencesUrl: `${process.env.INFER_USAGE_CLEAR_URL}?context=cached_inferences`
        };
    },
    b64EnvToAscii: function (env_var) {
        if (env_var in process.env) {
            var buff = Buffer.from(process.env[env_var], "base64");
            return buff.toString("ascii");
        } else if (!emulated && !process.env.JEST_WORKER_ID) {
            console.error(
                "Environment variable not available:",
                env_var,
                ". OK during initialization of the cloud function, but not during runtime. For a one-off script, please look at the documentation for secrets management. https://roboflow.slab.com/topics/secrets-management-pl58tt6v"
            );
        }
        return "undefined";
    },
    awsKeys: function () {
        return module.exports.b64EnvToAscii("AWS_SECRET_JSON_B64");
    },
    browserbaseConfig: function () {
        return { apiKey: process.env.BROWSERBASE_API_KEY };
    },
    slackConfig: function () {
        return {
            token: process.env.SLACK_TOKEN,
            userAlertsToken: process.env.USER_ALERTS_SLACK_TOKEN
        };
    },
    superAdmins: function () {
        // A list of users that can add/remove other admins via the admin panel.
        // This list is just a convenience for showing/hiding UI elements
        // in the frontend. The actual capabilities are encapsulated
        // in those users' JWT auth claims
        return env == "prod"
            ? [
                  "5w20VzQObTXjJhTjq6kad9ubrm33", // Brad Dwyer, CTO
                  "Ly2DeBzbwsemGd2ReHk4BFxy8683", // Joseph Nelson, CEO
                  "7KZi54uMlMh8cKhNlnczLDf7aqA3", // Sachin Agarwal, Infra Lead
                  "ZZYYwu6mWTTX7NY9RRbEkIIKDQs1", // Kate Wagner, Ops Lead
                  "dBpG2JyH97Vl1fzfkydRLszHlBg1" // Shawn Adams, IT Specialist
              ]
            : [
                  "eF616TpNiRbl6MniCL8FOD4rXX32", // Brad Dwyer, CTO
                  "o4h8f4QDj3Vcp0cbtfqiWIKRKK73", // Joseph Nelson, CEO
                  "EaIrqIKzQrWLXkNeZ7zOevsr17q1", // Sachin Agarwal, Infra Lead
                  "ZZYYwu6mWTTX7NY9RRbEkIIKDQs1", // Kate Wagner, Ops Lead
                  "zN8V4yvWZwRAROOUlERHejbC0tA3" // Shawn Adams, IT Specialist
              ];
    },
    turnServerConfig: function () {
        return env == "prod"
            ? {
                  secret: process.env.TURN_SERVER_SHARED_SECRET,
                  urls: "turn:turn1.roboflow.com:3478"
              }
            : {
                  secret: process.env.TURN_SERVER_SHARED_SECRET,
                  urls: "turn:turn1.roboflow.one:3478"
              };
    },
    roboflowApiAutomationsKey: function () {
        return module.exports.b64EnvToAscii("ROBOFLOW_API_AUTOMATIONS");
    },
    azureKey: function () {
        return module.exports.b64EnvToAscii("AZURE_COMPUTERVISION_USEAST_KEY");
    },
    openAIKey: function () {
        return module.exports.b64EnvToAscii("OPENAI_KEY");
    },
    googleVisionKey: function () {
        return module.exports.b64EnvToAscii("GOOGLE_VISION_KEY");
    },
    resendKey: function () {
        return module.exports.b64EnvToAscii("RESEND_KEY");
    },
    demoUrl: function () {
        return env == "prod" ? "https://demo.roboflow.com" : "https://demo.roboflow.one";
    },
    apolloConfig: function () {
        return { apiUrl: "https://api.apollo.io/v1/people/match", apiKey: process.env.APOLLO_KEY };
    },
    customerIoSiteId: function () {
        return env == "prod" ? "bd767cfa913dbbe0bac4" : "47e7e677319868074330";
    },
    customerIOConfig: function () {
        return {
            siteId: this.customerIoSiteId(),
            apiKey: process.env.CUSTOMER_IO_API_KEY,
            webhookSigningSecret: process.env.CUSTOMER_IO_WEBHOOK_SIGNING_KEY
        };
    },
    zoominfoConfig: function () {
        const clientId = module.exports.getEnvVar("ZOOMINFO_CLIENT_ID");
        const username = module.exports.getEnvVar("ZOOMINFO_USERNAME");
        const privateKey = module.exports.getEnvVar("ZOOMINFO_PRIVATE_KEY");
        const valueOrUndefined = (v) => (v === "not_set" ? undefined : v);
        return {
            baseUrl: "https://api.zoominfo.com",
            username: valueOrUndefined(username),
            privateKey: valueOrUndefined(privateKey),
            clientId: valueOrUndefined(clientId)
        };
    },
    apiUrl: function () {
        // if (emulated) return "http://127.0.0.1:5001/roboflow-staging/us-central1/light-v2-api";
        if (emulated) return "https://localapi.roboflow.one";
        return env == "prod" ? "https://api.roboflow.com" : "https://api.roboflow.one";
    },
    workflowAssistantUrl: function () {
        // Firebase hosting buffers the response on staging/prod.
        // We need to call the cloud function directly to enable streaming responses.
        if (emulated) {
            return "https://localapp.roboflow.one";
        } else if (env == "prod") {
            return "https://us-central1-roboflow-platform.cloudfunctions.net/light-v2-query";
        } else {
            return "https://us-central1-roboflow-staging.cloudfunctions.net/light-v2-query";
        }
    },
    uploadDomain: function () {
        return env == "prod" ? "upload.roboflow.com" : "upload.roboflow.one";
    },
    databaseURL: function () {
        return "https://" + name + ".firebaseio.com";
    },
    searchInvokerKeyFilename: function () {
        return module.exports.b64EnvToAscii("SEARCH_INVOKER_SECRET_JSON_B64");
    },
    stripeSecret: function () {
        return module.exports.b64EnvToAscii("STRIPE_KEY_SECRET_B64").replace("\n", "");
    },
    intercomAppId: function () {
        return env == "prod" ? "ehclfa58" : "iy92y09b";
    },
    intercomDevAccessToken: function () {
        // The Intercom dev access token is used to access the Intercom API
        return process.env.INTERCOM_DEV_ACCESS_TOKEN || "unset";
    },
    intercomInternalAccessToken: function () {
        // The internal access token is used to validate requests from Intercom to our API
        return process.env.INTERCOM_INTERNAL_ACCESS_TOKEN || "unset";
    },
    intercomConnectorClientSecret: function () {
        // The Intercom connector is used for the Intercom widget and the client secret verifies the request origin
        return process.env.INTERCOM_CONNECTOR_CLIENT_SECRET || "unset";
    },
    intercomSharedSupportAccountId: function () {
        if (env == "prod") {
            return "7844135";
        } else {
            return "7768950";
        }
    },
    intercomTeamIds: function () {
        if (env == "prod") {
            return { growthSales: "7779818", selfServeSupport: "7768952" };
        } else {
            return { growthSales: "8129885", selfServeSupport: "7809592" };
        }
    },
    ipdataConfig: function () {
        return { apiUrl: "https://api.ipdata.co", apiKey: process.env.IPDATA_API_KEY };
    },
    calendly: function () {
        return { signingKey: process.env.CALENDLY_WEBHOOK_SIGNING_KEY };
    },
    firebaseConsoleUrl: function () {
        if (env == "prod") {
            return "https://console.firebase.google.com/u/0/project/roboflow-platform/firestore/data/";
        } else {
            return "https://console.firebase.google.com/u/0/project/roboflow-staging/firestore/data/";
        }
    },
    gcpTrainBucket: function () {
        if (env == "prod") {
            return "https://console.cloud.google.com/storage/browser/roboflow-platform-train/REPLACE-OWNER-ID/REPLACE-DATASET-ID/REPLACE-VERSION?pageState=(%22StorageObjectListTable%22:(%22f%22:%22%255B%255D%22))&project=roboflow-platform&prefix=&forceOnObjectsSortingFiltering=false";
        } else {
            return "https://console.cloud.google.com/storage/browser/roboflow-staging-train/REPLACE-OWNER-ID/REPLACE-DATASET-ID/REPLACE-VERSION?pageState=(%22StorageObjectListTable%22:(%22f%22:%22%255B%255D%22))&project=roboflow-staging&prefix=&forceOnObjectsSortingFiltering=false";
        }
    },
    gcpCacheBucket: function () {
        if (env == "prod") {
            return "https://console.cloud.google.com/storage/browser/roboflow-platform-cache/REPLACE-OWNER-ID/REPLACE-DATASET-ID/REPLACE-VERSION?pageState=(%22StorageObjectListTable%22:(%22f%22:%22%255B%255D%22))&project=roboflow-platform&prefix=&forceOnObjectsSortingFiltering=false";
        } else {
            return "https://console.cloud.google.com/storage/browser/roboflow-staging-cache/REPLACE-OWNER-ID/REPLACE-DATASET-ID/REPLACE-VERSION?pageState=(%22StorageObjectListTable%22:(%22f%22:%22%255B%255D%22))&project=roboflow-staging&prefix=&forceOnObjectsSortingFiltering=false";
        }
    },
    adminUrl: function () {
        if (env == "prod") {
            return "https://admin.roboflow.com/";
        } else {
            return "https://admin.roboflow.one/";
        }
    },
    samEndpoint: function () {
        if (env == "prod") {
            return "https://smartpoly.svc.roboflow.com/smartpoly/v2/inference";
        } else {
            return "https://smartpoly.svc.roboflow.one/smartpoly/v2/inference";
        }
    },
    ritmEndpoint: function () {
        if (env == "prod") {
            return "https://smartpoly.svc.roboflow.com/smartpoly/v1/inference";
        } else {
            return "https://smartpoly.svc.roboflow.one/smartpoly/v1/inference";
        }
    },
    autoLabelInferenceUrl: function () {
        if (env == "prod") {
            return "https://inference-internal.crusoe.roboflow.com";
        } else {
            return "https://inference-internal.crusoe.roboflow.one";
        }
    },
    owlv2InferenceInternalEndpoint: function ({ forceStaging = false } = {}) {
        const url =
            env == "prod" && !forceStaging
                ? "https://inference-internal.crusoe.roboflow.com"
                : "https://inference-internal.crusoe.roboflow.one";
        return `${url}/owlv2/infer`;
    },
    // Useful when you want to hit the staging inference-internal even on prod to test
    // out flows while mitigating the risk of taking prod inference-internal down
    stagingInferenceInternalPassword: function () {
        return process.env.INFERENCE_INTERNAL_STAGING_PASSWORD;
    },
    inferenceInternalAuth: function () {
        return {
            username: process.env.INFERENCE_INTERNAL_USERNAME,
            password: process.env.INFERENCE_INTERNAL_PASSWORD
        };
    },
    inferenceInternalCookieName() {
        if (this.autoLabelInferenceUrl().includes("crusoe")) {
            return this.env() == "prod" ? "rf_inference_session_prd" : "rf_inference_session_stg";
        }
        // Default to Google Load Balancer cookie;
        return "GCLB";
    },
    gpuWorkflowUrl: function () {
        if (env == "prod") {
            return "https://serverless.roboflow.com/workflows/run";
        } else {
            return "https://serverless.roboflow.one/workflows/run";
        }
    },
    sheetsApiCredentials: function () {
        return JSON.parse(this.b64EnvToAscii("SHEETS_API_CREDENTIALS_JSON_B64"));
    },
    modelMonitoringServiceConfig: function () {
        return {
            apiUrl:
                env == "prod"
                    ? "https://model-monitoring-apiservice-li37nwjfaq-uc.a.run.app"
                    : "https://model-monitoring-apiservice-liwxmo5pvq-uc.a.run.app",
            sharedSecret: process.env.MODEL_MONITORING_SERVICE_SECRET,
            pubsubSecret: process.env.MODEL_MONITORING_PUBSUB_SECRET
        };
    },
    deviceMonitoringServiceConfig: function () {
        return {
            dbUrl: process.env.CLICKHOUSE_DEVICE_MONITORING_URL,
            keyId: process.env.DEVICE_MONITORING_SERVICE_KEY_ID,
            keySecret: process.env.DEVICE_MONITORING_SERVICE_KEY_SECRET,
            insertUrl: process.env.DEVICE_MONITORING_SERVICE_INSERT_URL,
            globalStatsUrl: process.env.DEVICE_MONITORING_SERVICE_GLOBAL_STATS_URL
        };
    },
    turnstileConfig: function () {
        return { siteKey: "0x4AAAAAAAXTyo9_qTPTwG_G", secretKey: process.env.TURNSTILE_SECRET_KEY };
    },
    docsWorkspaceId: function () {
        if (env === "prod") {
            return "JiQGYrduYqL8c9jTMgoQ";
        }

        return null;
    },
    searchConfig: function () {
        const indexUrl = process.env.SEARCH_CONFIG_INDEX_URL;
        const queryUrl = process.env.SEARCH_CONFIG_QUERY_URL;
        const searchConfig = {
            indexImageUrl: indexUrl + "/index_image",
            indexDatasetUrl: indexUrl + "/index_dataset",
            updateImageUrl: indexUrl + "/update_image",
            updateDatasetUrl: indexUrl + "/update_dataset",
            deleteImageUrl: indexUrl + "/delete_image",
            deleteDatasetUrl: indexUrl + "/delete_dataset",
            cleanupDeletedUrl: indexUrl + "/cleanup_deleted",
            queryImagesUrl: queryUrl + "/query-images",
            queryDatasetsUrl: queryUrl + "/query-datasets",
            roboqlQueryImagesUrl: queryUrl + "/roboql/images",
            workspaceTagsUrl: queryUrl + "/workspace-tags",
            workspacePointInTime: queryUrl + "/workspace/point_in_time",
            imagesIndex: "images",
            imagesIndexPerceptionEncoder: "pe-images",
            datasetsIndex: "datasets",
            deviceLogsIndex: "rfdm-device-logs",
            elasticsearchUrl: process.env.ELASTICSEARCH_URL
        };

        if (process.env.SEARCH_SECRET_JSON_B64) {
            var searchSecrets = JSON.parse(module.exports.b64EnvToAscii("SEARCH_SECRET_JSON_B64"));
            for (var k in searchSecrets) {
                if (!searchConfig[k]) searchConfig[k] = searchSecrets[k]; // fill in secrets but don't override local values
            }
        }

        return searchConfig;
    },
    roboflowSharedSecret: function () {
        return process.env.ROBOFLOW_SHARED_SECRET;
    },
    modelEvalConfig: function () {
        let asyncCanaryRatio = parseFloat(process.env.MODEL_EVAL_ASYNC_CANARY_RATIO); // will NOT throw error
        if (Number.isNaN(asyncCanaryRatio)) {
            asyncCanaryRatio = 0.0; // by default, disable canary on async
        }
        switch (env) {
            case "prod":
                return {
                    modelEvalDockerUri:
                        "us-central1-docker.pkg.dev/roboflow-platform/model-eval/model-eval",
                    gcpProjectId: "roboflow-platform",
                    gcpRegion: "us-central1",
                    roboflowApiUrl: "https://api.roboflow.com",
                    roboflowAppUrl: "https://app.roboflow.com",
                    objectDetectionInferenceEndpoint:
                        Math.random() <= asyncCanaryRatio
                            ? "https://asyncinfer.roboflow.com"
                            : "https://serverless.roboflow.com",
                    roboflowSharedSecret: process.env.ROBOFLOW_SHARED_SECRET
                };
            case "staging":
                return {
                    modelEvalDockerUri:
                        "us-central1-docker.pkg.dev/roboflow-staging/model-eval/model-eval",
                    gcpProjectId: "roboflow-staging",
                    gcpRegion: "us-central1",
                    roboflowApiUrl: "https://api.roboflow.one",
                    roboflowAppUrl: "https://app.roboflow.one",
                    objectDetectionInferenceEndpoint: "https://serverless.roboflow.one", // All serverless in stg is on Async already, there is no asyncinfer.roboflow.one endpoint
                    roboflowSharedSecret: process.env.ROBOFLOW_SHARED_SECRET
                };
            default:
                console.log("UNKNOWN PROJECT ENVIRONMENT", env);
                return {};
        }
    },
    salesforceConfig: function () {
        return {
            OrgIds: ["00D8c000002JHM3EAO", "00D8c000002JHM3"],
            username: "sfdc-admin@roboflow.com",
            grant_type: "password",
            client_id: process.env.SFDC_CLIENT_ID,
            client_secret: process.env.SFDC_CLIENT_SECRET,
            password: process.env.SFDC_ADMIN_PASSWORD,
            redirectUri: "https://login.salesforce.com",
            serverUrl: "https://roboflow1.my.salesforce.com",
            serviceBaseUrl: "https://roboflow1.my.salesforce.com/services"
        };
    },
    firebaseConfig: function () {
        switch (env) {
            case "prod":
                return {
                    projectId: "roboflow-platform",
                    appId: "1:481589474394:web:1e35528067deb71ccf9463",
                    databaseURL: "https://roboflow-platform.firebaseio.com",
                    storageBucket: "roboflow-platform-regional-sources",
                    locationId: "us-central",
                    apiKey: "AIzaSyDsw1Li1kplPtTZ_1mkkzgbGLX55KJcxWo",
                    authDomain: "app.roboflow.com",
                    messagingSenderId: "481589474394",
                    measurementId: "G-3991Z8P4PM"
                };
            case "staging":
                return {
                    projectId: "roboflow-staging",
                    appId: "1:878913763597:web:a3f48d2ca4084283475844",
                    databaseURL: "https://roboflow-staging.firebaseio.com",
                    storageBucket: "roboflow-staging-regional-sources",
                    locationId: "us-central",
                    apiKey: "AIzaSyBzxi_LPNPpPYI6jYjPTT0GjJnaybzoCFU",
                    authDomain: "app.roboflow.one",
                    messagingSenderId: "878913763597"
                };
            default:
                console.log("UNKNOWN PROJECT ENVIRONMENT", env);
                return {};
        }
    },
    cdnHost: function () {
        return env == "prod" ? "source.roboflow.com" : "source.roboflow.one";
    },
    trainBucketHost: function () {
        return env == "prod" ? "repo.roboflow.com" : "repo.roboflow.one";
    },
    userContentCdnHost: function () {
        return env == "prod"
            ? "https://usercontent.roboflowstatic.com"
            : "https://staging-usercontent.roboflowstatic.com";
    },
    bucket: function (bucket) {
        if (bucket == "train-log") {
            return "com-roboflow-failed-train-logs-" + env;
        }
        if (bucket == "data-sharing") {
            return "data-sharing-" + env;
        }
        const migrated_buckets = ["exports", "sources", "transforms"];
        if (migrated_buckets.includes(bucket)) {
            return name + "-regional-" + bucket;
        } else {
            return name + "-" + bucket;
        }
    },
    sampleDataset: function () {
        return env == "prod" ? "OXcbAdpFrioGUqaxPaZo" : "7I0RZYmP3u9yZgt4y28T";
    },
    largeWorkspaces: function () {
        //Link to WStLbW6Owiz8aE9Z5N23 --> https://app.roboflow.com/large-benchmark-datasets
        return env == "prod" ? ["WStLbW6Owiz8aE9Z5N23"] : ["MJSD3qwKcGesS9WMDZ4z"];
    },
    isTestAccount: function (uid) {
        return ["M5cW8kOMUTYeQSx7gzruDys3t6j1", "BTbkIboA2XeK0nawHIY9gjL7aPe2"].includes(uid);
    },
    supportTeam: function () {
        return {
            id: env == "prod" ? "d83QKocE3qOxGTdMw3el" : "vQc6ThnzdwcmAjlxNoSZ",
            name: "Roboflow Support",
            color: "#5c6ac4",
            icon: "fad fa-user-headset"
        };
    },
    billingUsageServiceConfig: function () {
        const redisHost = emulated
            ? process.env.EMULATED_REDIS_HOST_PORT || "localhost:6379"
            : env == "prod"
              ? "10.227.65.20:6379"
              : "10.88.148.156:6379";
        return { redisHost };
    },
    redisConfig: function () {
        return emulated
            ? process.env.EMULATED_REDIS_HOST_PORT || "localhost:6379"
            : env == "prod"
              ? "10.244.146.180:6379"
              : "10.203.137.12:6379";
    },
    redisFlushConfig: function () {
        if (emulated) {
            return { host: "localhost", port: 6379 };
        }
        return { host: env == "prod" ? "10.145.83.100" : "10.94.216.124", port: 6379 };
    },
    vpcConnector: function () {
        return env == "prod" ? "elasticsearch" : "indexer-staging";
    },
    vpcConnectorCloudRun: function () {
        return "cloudrun-connector";
    },
    supportUser: function () {
        return {
            id: env == "prod" ? "9ktbryvmx3bot1H2TsLNLotPR2C3" : "HurMd3PzDzUwL6PVID6ixDU0jg03",
            email: "help@roboflow.com"
        };
    },
    stripeSigningSecret: function () {
        return process.env.STRIPE_SIGNING_SECRET || "not_set";
    },
    stripe: function () {
        if (env === "prod") {
            return {
                publishable_key: "pk_live_bkyBGUk4zrQEooH7WnY4a9rv00rPgkXgkJ",
                starter_plan: {
                    productId: "prod_NbWTXr8J4ozZGr",
                    priceId: "price_1MqJQBJRyZoEkwsroBCdiRmG",
                    annualPriceId: "price_1MqJbEJRyZoEkwsrDnkbu47n",

                    expansionProductId: "prod_NzuY8AA0dikwf0", // legacy
                    expansionPriceId: "price_1NDujQJRyZoEkwsr9sSsQScJ", // legacy
                    expansionAnnualPriceId: "price_1NDujQJRyZoEkwsrcDHk7Nwj", // legacy
                    legacyProductId: "prod_NMwVbgaeXoOVuO", //legacy

                    customExpansion: {
                        images: {
                            productId: "prod_OIGBguUoOK721Z",
                            priceId: "price_1NVffbJRyZoEkwsrBjcFaiOB",
                            upsellPriceId: "price_1NVffbJRyZoEkwsrA2vvGWdY",
                            upsellDiscountPercent: 0.2,
                            pricePerUnit: 19,
                            quantityPerUnit: 1000,
                            max: Infinity
                        },
                        inferences: {
                            productId: "prod_OIGDKiELQAbrOK",
                            priceId: "price_1NbClQJRyZoEkwsruI3FNXYM",
                            upsellPriceId: "price_1NbCltJRyZoEkwsropp4ltms",
                            upsellDiscountPercent: 0.2,
                            pricePerUnit: 3,
                            quantityPerUnit: 1000,
                            max: Infinity
                        },
                        adminCollaborators: {
                            productId: "prod_OIGEApGkv0zTu6",
                            priceId: "price_1NVfi5JRyZoEkwsreBCW8FPU",
                            upsellPriceId: "price_1NVfi5JRyZoEkwsr6dMHn6ON",
                            upsellDiscountPercent: 0.2,
                            pricePerUnit: 99,
                            quantityPerUnit: 1,
                            max: Infinity
                        },
                        trainCredits: {
                            productId: "prod_OIGGyKjZNePnCd",
                            priceId: "price_1NijYHJRyZoEkwsrUB67yWl7",
                            upsellPriceId: "price_1NijY5JRyZoEkwsruKeO4A1z",
                            upsellDiscountPercent: 0.2,
                            pricePerUnit: 60,
                            quantityPerUnit: 5,
                            max: Infinity
                        },
                        rbac: {
                            productId: "prod_OXD3mWPu8d3F8y",
                            priceId: "price_1Nk8dWJRyZoEkwsrkOzuj3C9",
                            upsellPriceId: "price_1NkTICJRyZoEkwsreMoESkFf",
                            upsellDiscountPercent: 0.2,
                            pricePerUnit: 179,
                            quantityPerUnit: 1,
                            max: 1,
                            labelers: 5,
                            reviewers: 2
                        }
                    },

                    offers: {
                        oak: {
                            priceId: "price_1OEjSzJRyZoEkwsrP8xgxgT3",
                            displayName: "OAK-D Lite"
                        },
                        outsourcedLabeling: {
                            priceId: "price_1OEjT6JRyZoEkwsrTnwxGmoJ",
                            displayName: "Free Outsourced Labeling"
                        },
                        trainingCredits: {
                            priceId: "price_1OP92oJRyZoEkwsrc3zCqvog",
                            displayName: "30 Training Credits"
                        }
                    }
                },
                basic_plan: {
                    productId: "prod_RF3qLWCLf2ksyA",
                    priceId: "price_1QMZj2JRyZoEkwsrXlaSAV6P",
                    annualPriceId: "price_1QMZj2JRyZoEkwsr303949Ie"
                },
                core_plan: {
                    productId: "prod_TWeuYOVbht1qyT",
                    priceId: "price_1SZbb0JRyZoEkwsrfieBZzNY",
                    annualPriceId: "price_1SZbb0JRyZoEkwsrnyghWGIy"
                },
                growth_plan: {
                    productId: "prod_RF3pzEPmLtxyei",
                    priceId: "price_1QMZi7JRyZoEkwsrU4lXzDGx",
                    annualPriceId: "price_1QMZi7JRyZoEkwsrQH3JtQZ5"
                },
                auto_label: {
                    productId: "prod_PmSHPamzyKPXfB",
                    default: [
                        { priceId: "price_1OzNERJRyZoEkwsropzg9WCO", price: 15, credits: 500 },
                        { priceId: "price_1OwtMnJRyZoEkwsrGItRz309", price: 29, credits: 1000 },
                        // {
                        //     priceId: "price_1OwtMnJRyZoEkwsrZjWTlEsE",
                        //     price: 69,
                        //     credits: 2500
                        // },
                        { priceId: "price_1OwtMnJRyZoEkwsrJP1jPdkY", price: 129, credits: 5000 },
                        { priceId: "price_1OwtMnJRyZoEkwsrHVqy425m", price: 249, credits: 10000 }
                    ],
                    starter: [
                        { priceId: "price_1OwtMnJRyZoEkwsr1mNFM06T", price: 49, credits: 2500 },
                        { priceId: "price_1OwtMnJRyZoEkwsreJdT8aCn", price: 179, credits: 10000 },
                        { priceId: "price_1OwtMnJRyZoEkwsr7ZbIRfAu", price: 349, credits: 25000 },
                        { priceId: "price_1OwtMnJRyZoEkwsrngEBtePJ", price: 599, credits: 50000 },
                        { priceId: "price_1OwtMnJRyZoEkwsrxaL62Kei", price: 999, credits: 100000 }
                    ]
                },
                flex_usage: {
                    hostedInferencesProductId: "prod_R0XXQQg3v3s0Hv",
                    hostedInferencesPriceId: "price_1Q8WSRJRyZoEkwsr9ejM1h3k",
                    roboflowCreditsProductId: "prod_REg4TqxQk90Mi6",
                    roboflowCreditsMeterId: "mtr_61RVafJinVykqTl7T41JRyZoEkwsrTYu",
                    roboflowPrepaidCreditsProductId: "prod_RbDh2bGTqYEiiU"
                }
            };
        }
        return {
            publishable_key: "pk_test_vDJd8VmO7HZc8B6h0jCNAptE00rSMNQP0T",
            starter_plan: {
                productId: "prod_NUwbi9IdrEVD0J",
                priceId: "price_1MjwhvJRyZoEkwsrP7sn14La",
                annualPriceId: "price_1MjwnLJRyZoEkwsr9YsZvir7",

                expansionProductId: "prod_NxJjjUh651goW8",
                expansionPriceId: "price_1NBP6LJRyZoEkwsri2xLnxrX",
                expansionAnnualPriceId: "price_1NDukZJRyZoEkwsr76ORtokV",

                legacyProductId: "_",

                // TODO: create method in stripeService to get and parse product/price info
                // since Stripe will be our source of truth for this info. We don't want changes
                // made to Stripe to get out of sync with the hard-coded values here.
                customExpansion: {
                    images: {
                        productId: "prod_OFFvyvrVWDMuUe",
                        priceId: "price_1NSlPgJRyZoEkwsrthqRynyB",
                        upsellPriceId: "price_1NSlPgJRyZoEkwsrRUF8xR9g",
                        upsellDiscountPercent: 0.2,
                        pricePerUnit: 19,
                        quantityPerUnit: 1_000,
                        max: Infinity
                    },
                    inferences: {
                        productId: "prod_OFFy3aApSb08f6",
                        priceId: "price_1NbCjQJRyZoEkwsr2FrGJQ4D",
                        upsellPriceId: "price_1NbCkhJRyZoEkwsrpBE3XMAB",
                        upsellDiscountPercent: 0.2,
                        pricePerUnit: 3,
                        quantityPerUnit: 1000,
                        max: Infinity
                    },
                    adminCollaborators: {
                        productId: "prod_OFG2a8tc94BvSU",
                        priceId: "price_1NSlWdJRyZoEkwsrwS5BNw5C",
                        upsellPriceId: "price_1NSlWdJRyZoEkwsrHfxPUvon",
                        upsellDiscountPercent: 0.2,
                        pricePerUnit: 99,
                        quantityPerUnit: 1,
                        max: Infinity
                    },
                    trainCredits: {
                        productId: "prod_OFG54WVsWJPdTL",
                        priceId: "price_1NijUOJRyZoEkwsrBrLCv9y5",
                        upsellPriceId: "price_1PIe4jJRyZoEkwsrz2uR9fQd",
                        upsellDiscountPercent: 0.2,
                        pricePerUnit: 60,
                        quantityPerUnit: 5,
                        max: Infinity
                    },
                    rbac: {
                        productId: "prod_OXCwZxoB0qjdBP",
                        priceId: "price_1NkSa1JRyZoEkwsrXVXBHLZg",
                        upsellPriceId: "price_1NkTGCJRyZoEkwsrByzQMpQQ",
                        upsellDiscountPercent: 0.2,
                        pricePerUnit: 179,
                        quantityPerUnit: 1,
                        max: 1,
                        labelers: 5,
                        reviewers: 2
                    }
                },

                offers: {
                    oak: { priceId: "price_1OEhjHJRyZoEkwsrUxzpfSQJ", displayName: "OAK-D Lite" },
                    outsourcedLabeling: {
                        priceId: "price_1OEhjuJRyZoEkwsrKDzHX4HX",
                        displayName: "Free Outsourced Labeling"
                    },
                    trainingCredits: {
                        priceId: "price_1OP8kxJRyZoEkwsrxzmZrSL1",
                        displayName: "30 Training Credits"
                    }
                }
            },
            basic_plan: {
                productId: "prod_RCReiKt7YsfX8U",
                priceId: "price_1QKqE4JRyZoEkwsr1v90svDs",
                annualPriceId: "price_1QKqERJRyZoEkwsrQy8LVwmi"
            },
            core_plan: {
                productId: "prod_TWf0Mffe1hSmJu",
                priceId: "price_1SZbguJRyZoEkwsrDIh8zS3O",
                annualPriceId: "price_1SZbguJRyZoEkwsrwFrvvrNG"
            },
            growth_plan: {
                productId: "prod_RCRfDJ4EAIUm3P",
                priceId: "price_1QKqFQJRyZoEkwsry28Eo9MW",
                annualPriceId: "price_1QKqFoJRyZoEkwsr65fNbfP3"
            },
            auto_label: {
                productId: "prod_Pm51cqMehMnLpF",
                default: [
                    { priceId: "price_1OzN2SJRyZoEkwsrB541mZ3u", price: 15, credits: 500 },
                    { priceId: "price_1OwswQJRyZoEkwsrIwbF4qIp", price: 29, credits: 1000 },
                    // {
                    //     priceId: "price_1OwswgJRyZoEkwsrPpae0JGh",
                    //     price: 69,
                    //     credits: 2500
                    // },
                    { priceId: "price_1OwswvJRyZoEkwsrx5PyktZf", price: 129, credits: 5000 },
                    { priceId: "price_1Owsx7JRyZoEkwsr5WKJkBZe", price: 249, credits: 10000 }
                ],
                starter: [
                    { priceId: "price_1OwYe3JRyZoEkwsrAZDFdu3e", price: 49, credits: 2500 },
                    { priceId: "price_1OwYeYJRyZoEkwsru0GLa6mL", price: 179, credits: 10000 },
                    { priceId: "price_1OwYevJRyZoEkwsrOBG0vl2z", price: 349, credits: 25000 },
                    { priceId: "price_1OwYf6JRyZoEkwsrWG7fYGwH", price: 599, credits: 50000 },
                    { priceId: "price_1OwYfMJRyZoEkwsrOoEyGsvi", price: 999, credits: 100000 }
                ]
            },
            flex_usage: {
                hostedInferencesProductId: "prod_R0V9be1Wv6zzuW",
                hostedInferencesPriceId: "price_1Q8U9aJRyZoEkwsrhH6QEROz",
                roboflowCreditsProductId: "prod_REdfXECVONNUA0",
                roboflowCreditsMeterId: "mtr_test_61RHrroTof4RYXhyQ41JRyZoEkwsr1p2",
                roboflowPrepaidCreditsProductId: "prod_RbBSVqpryAoV3A"
            }
        };
    },
    stripeProduct: function (name) {
        switch (name) {
            // old image-hour pricing
            // case 'source_image': return env == "prod" ? "price_HMzKZsy8oDeXOs" : "price_HNqPXgOdk1sLWP";
            // case 'generated_image': return env == "prod" ? "price_HMzLqYIJKnMQDX" : "price_HNqPwzsx3uhIMQ";

            // new image-month pricing (max usage for the month)
            case "source_image":
                return env == "prod"
                    ? "price_1GvnZFJRyZoEkwsrtnGJVH6F"
                    : "price_1Gvna6JRyZoEkwsrU0Xe2XTO";
            case "generated_image":
                return env == "prod"
                    ? "price_1GvnVoJRyZoEkwsrxQD8MA88"
                    : "price_1GvnacJRyZoEkwsrLfmh2ZI0";
        }
    },
    stripeCoupons: function () {
        return { opencv: env == "prod" ? "LOoC4uzG" : "TJYNN79x" };
    },
    bigQueryDataset: function () {
        if (env === "prod") return "roboflow_app_server_prod";
        return "roboflow_app_staging";
    },
    bigQueryWorkspace: function () {
        if (env === "prod") return "roboflow-platform.roboflow_app_server_prod";

        return "roboflow-staging.roboflow_app_staging";
    },
    bigQueryUniverseDatasetStatsTable: function () {
        // these tables are materalized views optimized for querying that are written daily via BQ scheduled queries
        if (env == "prod")
            return "roboflow-platform.product_scheduled_query_results.prod_universe_dataset_stats";
        else
            return "roboflow-platform.product_scheduled_query_results.staging_universe_dataset_stats";
    },
    clickhouseDeviceMonitoringService: function () {
        if (env == "prod") {
            return "b83fbb27-f073-43f3-97ee-7fa617932d4e";
        } else {
            return "3049c8e5-c202-4d33-84cc-7fbd4e9abf26";
        }
    },
    projectId: function () {
        return name;
    },
    segment: function () {
        if (env === "prod") {
            return { internalScriptWriteKey: process.env.SEGMENT_INTERNAL_SCRIPT_WRITE_KEY };
        } else {
            return { internalScriptWriteKey: "ELfHvGRZoIE3q2shXlWQmwJoycPMhGI2" };
        }
    },
    frontendSegmentWriteKey: function () {
        return env === "prod"
            ? "eXtDJCxffULSITBEV2KMzv7MwuBkMvty"
            : "HBZHcbQpVRUB7cA1KNGMsrGy3rhX58GL";
    },
    reddit: function () {
        if (env === "prod") {
            return {
                appId: "a2_givxsedjefz9",
                eventAccessToken: process.env.REDDIT_EVENT_ACCESS_TOKEN
            };
        } else {
            return {
                appId: "a2_gknkiaps6sl9",
                eventAccessToken: process.env.REDDIT_EVENT_ACCESS_TOKEN
            };
        }
    },
    allBaseRoles: function () {
        return ["owner", "labeler", "reviewer"];
    },
    internalAuthTokens: function () {
        const usageOverageToken = process.env.USAGE_OVERAGE_ENDPOINT_TOKEN;
        return { usageOverageToken };
    },
    RestrictedReason: {
        NoPaymentMethod: "no_payment_method",
        PastDue: "past_due",
        Churned: "churned"
    },
    DEFAULT_USAGE: {
        plan: "free",
        billing: false,
        pro: false,
        restricted: false,

        limit: {
            sources: 1000,
            transforms: 5000,
            collaborators: 5,
            projects: 100,
            variantsPerImage: 3,
            soft: false
        },

        train: { quota: 0, used: 0 },

        oak: { limit: 5, mau: 0 },

        tfjs: { limit: 1000, mau: 0 },

        coreml: { limit: 1, mau: 0 },

        soft: false,
        inference: {
            soft: false,
            quota: 1000,
            used: 0,
            billing_period: "monthly", // monthly | annual
            last_billed_on: null,
            replenish_after_billing: true
        },

        threshold: 100, // in dollars
        rates: {
            // in millicents ($0.00001 or *100k=$)
            sources: 1000,
            transforms: 200
        },

        total: 0,
        images: { sources: 0, transforms: 0 },

        features: {
            creditSystem: false,
            allowPrivateProjects: true,
            apiUpload: true,
            emailUpload: true,
            videoProcessing: false,
            healthCheck: true,
            clipSearch: false,
            outsourcedAnnotations: false,
            advancedTransforms: false,
            exportVersion: false,
            cloudMlIntegrations: false,
            tfjsInBrowser: "dev_only",
            edgeInference: "forbidden",
            embedInMobileApps: false,
            offlineMode: false,
            vpcDeployment: false,
            supportLevel: "None",
            annotationReview: false,
            workspaceInsights: false,
            classAttributes: false,
            advancedLabelAssist: false,
            deviceMonitoring: false,
            rbac: false,
            highComplexitySmartPoly: false,
            modelEvaluation: false,
            manage_workflows: false,
            sessionRecording: false,
            refreshAnnotationsButton: false,
            unlimitedTimeDedicatedDeployments: false,
            billSelfHostedDeployments: false
        },

        workspace: { isSetup: true, team: true, plan: "legacy" },

        ubp: { includedCredits: 15, creditCap: 15, pricePerCredit: 2 },

        maxCreditsPerStream: null, // effectively equals "default", which lets us change the default in the future

        acceptedCancelOffer: false
    },
    getInferenceUsageConfig: function () {
        return {
            shared_aws_secret: process.env.INFERENCE_USAGE_SHARED_AWS_SECRET,
            roboflow_internal_secret: process.env.ROBOFLOW_INTERNAL_SERVICE_SECRET
        };
    },
    getInternalServiceIPs: function () {
        if (env == "prod") {
            const prod_us_central1_v3_ips = [
                "34.173.53.185",
                "34.44.85.169",
                "34.42.204.83",
                "35.238.79.163",
                "104.155.129.44",
                "35.224.68.25",
                "34.68.156.103",
                "35.225.40.58"
            ];
            const ded_us_central1_v1_ips = ["35.223.93.90", "34.135.139.5"];
            return [...prod_us_central1_v3_ips, ...ded_us_central1_v1_ips];
        } else {
            const staging_us_central1_v3_ips = ["104.154.94.6", "34.41.38.81", "35.226.76.52"];
            const ded_us_central1_v1_ips = ["34.31.100.121", "34.122.58.72"];
            return [...staging_us_central1_v3_ips, ...ded_us_central1_v1_ips];
        }
    },
    getEnvVar: function (env_name) {
        if (process.env[env_name]) {
            return process.env[env_name];
        } else {
            if (!process.env.JEST_WORKER_ID) {
                console.error(env_name, " is not set, returning dummy value of not_set");
            }
            return "not_set";
        }
    },
    fbExportBucket: function () {
        if (env == "prod") {
            return "roboflow-periodic-backups-prod"; //To be created.
        } else {
            return "roboflow-periodic-backups-staging";
        }
    },
    envDomain: function () {
        if (env == "prod") {
            return "roboflow.com";
        } else {
            return "roboflow.one";
        }
    },
    trainClusters: function () {
        if (env == "prod") {
            return {
                "goog-us-central1": {
                    k8sClusterName: "k8s-prod-v3",
                    region: "us-central1",
                    projectId: "roboflow-platform",
                    hasSpot: true,
                    hasOndemand: true,
                    timeZone: "America/Chicago",
                    location: "US"
                },
                "goog-eu-west4": {
                    k8sClusterName: "k8s-prod-eu-v3",
                    region: "europe-west4",
                    projectId: "roboflow-platform-eu",
                    hasSpot: true,
                    hasOndemand: true,
                    timeZone: "Europe/Amsterdam",
                    location: "EU"
                },
                "crusoe-train": {
                    kubeconfigContent: process.env.CRUSOE_KUBECONFIG,
                    kubeconfigContext: process.env.CRUSOE_KUBECONFIG_CONTEXT,
                    k8sClusterName: "crusoe-train",
                    region: "us-central1",
                    projectId: "roboflow-platform",
                    hasSpot: false,
                    hasOndemand: true,
                    timeZone: "America/Chicago",
                    location: "US"
                }
            };
        } else {
            return {
                "goog-us-central1": {
                    k8sClusterName: "k8s-staging-v3",
                    region: "us-central1",
                    projectId: "roboflow-staging",
                    hasSpot: true,
                    hasOndemand: true,
                    timeZone: "America/Chicago",
                    location: "US"
                },
                "goog-eu-west4": {
                    k8sClusterName: "k8s-staging-eu-v3",
                    region: "europe-west4",
                    projectId: "roboflow-staging-eu",
                    hasSpot: true,
                    hasOndemand: true,
                    timeZone: "Europe/Amsterdam",
                    location: "EU"
                },
                "crusoe-train": {
                    kubeconfigContent: process.env.CRUSOE_KUBECONFIG,
                    kubeconfigContext: process.env.CRUSOE_KUBECONFIG_CONTEXT,
                    k8sClusterName: "crusoe-train",
                    region: "us-central1",
                    projectId: "roboflow-staging",
                    hasSpot: false,
                    hasOndemand: true,
                    timeZone: "America/Chicago",
                    location: "US"
                }
            };
        }
    },
    trainClusterDefault: function () {
        return "goog-us-central1";
    },
    spotTrainCanaryFractionSmall: function () {
        return process.env.SPOT_TRAIN_CANARY_FRACTION_SMALL || 0.0;
    },
    spotTrainCanaryFractionMedium: function () {
        return process.env.SPOT_TRAIN_CANARY_FRACTION_MEDIUM || 0.0;
    },
    spotTrainCanaryFractionLarge: function () {
        return process.env.SPOT_TRAIN_CANARY_FRACTION_LARGE || 0.0;
    },
    videoBatchInferenceEndpoint: function () {
        return process.env.VIDEO_BATCH_INFERENCE_ENDPOINT;
    },
    videoBatchInferenceKey: function () {
        return process.env.VIDEO_API_KEY;
    },
    autodistillBucketName: function () {
        if (env == "prod") {
            return "com-roboflow-autodistill-prod";
        } else {
            return "com-roboflow-autodistill-staging";
        }
    },
    firebaseAppCheckSiteKey: function () {
        if (env == "prod") {
            return "6Ld3XV0pAAAAAGat8anPuStU8ZWs_zWPmMRiXLoT";
        } else {
            return "6LdsnFkpAAAAAMe1k9bn5ja5gbb4RBIgtu4Zu4-J";
        }
    },
    yolonasCocoModels: function () {
        if (env == "prod") {
            return {
                url: "coco",
                name: "MS COCO",
                owner: "BTRTpB7nxxjUchrOQ9vT",
                type: "object-detection",
                versions: [
                    {
                        name: "Best",
                        annotation: "Common Objects",
                        modelType: "yolo_nas_s",
                        tfjs: false,
                        id: "14",
                        results: { map: 0.522 }
                    },
                    {
                        name: "Best",
                        annotation: "Common Objects",
                        modelType: "yolo_nas_m",
                        tfjs: false,
                        id: "15",
                        results: { map: 0.54 }
                    },
                    {
                        name: "Best",
                        annotation: "Common Objects",
                        modelType: "yolo_nas_l",
                        tfjs: false,
                        id: "16",
                        results: { map: 0.487 }
                    }
                ]
            };
        } else {
            return {
                url: "microsoft-coco-obj-det",
                name: "MS COCO",
                owner: "FN0yEKLaCQ2GuQH48CvZ",
                type: "object-detection",
                versions: [
                    {
                        name: "Best",
                        annotation: "Common Objects",
                        modelType: "yolo_nas_s",
                        tfjs: false,
                        id: "5",
                        results: { map: 0.522 }
                    },
                    {
                        name: "Best",
                        annotation: "Common Objects",
                        modelType: "yolo_nas_m",
                        tfjs: false,
                        id: "6",
                        results: { map: 0.54 }
                    },
                    {
                        name: "Best",
                        annotation: "Common Objects",
                        modelType: "yolo_nas_l",
                        tfjs: false,
                        id: "7",
                        results: { map: 0.487 }
                    }
                ]
            };
        }
    },

    sessionTrackerConnection: function () {
        if (env == "prod") {
            return {
                projectKey: "Uj4WTWXT7p4LLJooieNv",
                ingestPoint: "https://sessions.roboflow.com/ingest"
            };
        } else {
            return {
                projectKey: "ZVpLnmOJ8J3cwAE6HRJ5",
                ingestPoint: "https://sessions.roboflow.one/ingest"
            };
        }
    },

    sentryDsn: function () {
        return "https://82998ea7043238f53974072fca79f12d@o4510150417383424.ingest.us.sentry.io/4510150426558464";
    },

    getImageSuggestionsDataset: function () {
        if (env === "prod") {
            // Objects 365
            // https://universe.roboflow.com/objects-365-consortium/objects-365/
            return { workspaceId: "8IqlCQUz92pfe9BWFgXB", projectId: "rsh8bxDtSqQ2LHdfiGNi" };
        }

        return {
            // COCO on staging
            workspaceId: "FVVkJB2vNZhxNczSPQGx0P93ZRr1",
            projectId: "zMa1LFwSzQsHwkoVYBRw"
        };
    },
    getCocoModel() {
        return env === "prod" ? "coco/3" : "coco-test/1";
    },

    getAssumeIdentityServiceAccessToken: function () {
        return process.env.ASSUME_IDENTITY_SERVICE_ACCESS_TOKEN;
    },

    getExternalUsageReporterAccessToken: function () {
        return process.env.EXTERNAL_USAGE_REPORTER_ACCESS_TOKEN;
    },

    spannerConfig() {
        return {
            projectId: this.name(),
            instanceId: `spanner-instance-${env == "prod" ? "production" : "staging"}`,
            databaseId: "roboflow"
        };
    },

    getDataStagingBucket: function () {
        if (env === "prod") {
            return "roboflow-production-data-staging";
        }
        return "roboflow-staging-data-staging";
    },

    getBatchProcessingPubSubTopic: function () {
        if (env === "prod") {
            return "projects/rf-batch-prod/topics/roboflow-production-batch-processing-events";
        }
        return "projects/rf-batch-staging/topics/roboflow-staging-batch-processing-events";
    },

    getDataStagingServiceSecret: function () {
        return process.env.DATA_STAGING_SERVICE_SECRET;
    },

    getBatchProcessingServiceSecret: function () {
        return process.env.BATCH_PROCESSING_SERVICE_SECRET;
    },

    getExperimentalFeaturesServiceSecret: function () {
        return process.env.EXPERIMENTAL_FEATURES_SERVICE_SECRET;
    },

    getWorkflowsServiceUrl: function () {
        if (env === "prod") {
            return "https://serverless.roboflow.com";
        }
        return "https://serverless.roboflow.one";
    },

    getBatchProcessingBucket: function () {
        if (env === "prod") {
            return "roboflow-production-batch-processing";
        }
        return "roboflow-staging-batch-processing";
    },

    getDataStagingPubSubTopic: function () {
        if (env === "prod") {
            return "projects/rf-batch-prod/topics/roboflow-production-image-shards-uploaded";
        }
        return "projects/rf-batch-staging/topics/roboflow-staging-image-shards-uploaded";
    },

    getModelsServiceInternalSecret: function () {
        return process.env.MODELS_SERVICE_INTERNAL_SECRET;
    },

    getModelsServiceInternalSecretReference: function () {
        if (env == "prod") {
            return "projects/481589474394/secrets/MODELS_SERVICE_INTERNAL_SECRET";
        } else {
            return "projects/878913763597/secrets/MODELS_SERVICE_INTERNAL_SECRET";
        }
    },

    gcpTrainBucketName: function () {
        if (env == "prod") {
            return "roboflow-platform-train";
        } else {
            return "roboflow-staging-train";
        }
    },

    gcpCoreModelsBucketName: function () {
        if (env == "prod") {
            return "roboflow-platform-core-models";
        } else {
            return "roboflow-staging-core-models";
        }
    },

    gcpTRTCOmpilationBucket: function () {
        if (env == "prod") {
            return "roboflow-platform-trt-compilation";
        } else {
            return "roboflow-staging-trt-compilation";
        }
    },

    r2CoreModelsBucketName: function () {
        return env == "prod"
            ? "roboflow-prod-core-models-cache"
            : "roboflow-staging-core-models-cache";
    },

    r2Endpoint() {
        return env == "prod"
            ? "https://core-models.roboflow.com"
            : "https://core-models.roboflow.one";
    }
};

module.exports = project;
